(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-about"]) return;
  try {
    
  (() => {
    const normaliseFounderMedia = (media) => {
      if (!media) return;

      const image = media.querySelector("img");
      if (!image) return;

      if (image.parentElement !== media || media.children.length !== 1) {
        image.remove();
        media.replaceChildren(image);
      }

      image.removeAttribute("width");
      image.removeAttribute("height");
      image.style.removeProperty("width");
      image.style.removeProperty("height");
      image.style.removeProperty("max-width");
      image.style.removeProperty("margin");
    };

    const buildFounderCards = (founders) => {
      if (!founders) return;

      const existingCards = founders.querySelectorAll(":scope > .strobe-about__founder-card");
      if (existingCards.length) {
        existingCards.forEach((card) => {
          normaliseFounderMedia(card.querySelector(".strobe-about__founder-media"));
        });
        return;
      }

      const children = Array.from(founders.children);
      const headingIndexes = children
        .map((node, index) => node.matches("h3") ? index : -1)
        .filter((index) => index >= 0);

      headingIndexes.forEach((startIndex, groupIndex) => {
        const endIndex = headingIndexes[groupIndex + 1] ?? children.length;
        const group = children.slice(startIndex, endIndex);
        const imageHost = group.find((node) =>
          node.matches("img") || Boolean(node.querySelector("img"))
        );
        const image = imageHost
          ? (imageHost.matches("img") ? imageHost : imageHost.querySelector("img"))
          : null;
        const card = document.createElement("article");
        const media = document.createElement("div");
        const copy = document.createElement("div");

        card.className = "strobe-about__founder-card";
        media.className = "strobe-about__founder-media";
        copy.className = "strobe-about__founder-copy";

        if (imageHost) imageHost.remove();

        group.forEach((node) => {
          if (node === imageHost) return;
          copy.appendChild(node);
        });

        if (image) {
          media.appendChild(image);
          normaliseFounderMedia(media);
          card.appendChild(media);
        }

        card.appendChild(copy);
        founders.appendChild(card);
      });
    };

    const wrapFounders = (root = document) => {
      root.querySelectorAll(".strobe-about__body").forEach((body) => {
        let founders = body.querySelector(":scope > .strobe-about__founders");

        if (!founders) {
          const children = Array.from(body.children);
          const start = children.find((node) =>
            node.matches("h2") && node.textContent.trim().toLowerCase() === "the founders"
          );

          if (!start) return;

          const startIndex = children.indexOf(start);
          const end = children.slice(startIndex + 1).find((node) => node.matches("h2"));
          founders = document.createElement("section");

          founders.className = "strobe-about__founders";
          founders.setAttribute("aria-labelledby", "strobe-about-founders-title");
          start.id = "strobe-about-founders-title";
          body.insertBefore(founders, start);

          let node = start;
          while (node && node !== end) {
            const next = node.nextElementSibling;
            founders.appendChild(node);
            node = next;
          }
        }

        buildFounderCards(founders);
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => wrapFounders(), { once: true });
    } else {
      wrapFounders();
    }

    document.addEventListener("shopify:section:load", (event) => wrapFounders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-browser-wishlist"]) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'strobe_wishlist';
    const root = document.querySelector('.strobe-wishlist-system');
    if (!root || window.StrobeWishlist) return;

    const labels = {
      add: root.dataset.labelAdd,
      remove: root.dataset.labelRemove,
      saved: root.dataset.labelSaved,
      view: root.dataset.labelView,
      unavailable: root.dataset.labelUnavailable,
      viewProduct: root.dataset.labelViewProduct,
      addToCart: root.dataset.labelAddCart,
      addingToCart: root.dataset.labelAddingCart,
      addedToCart: root.dataset.labelAddedCart,
      cartError: root.dataset.labelCartError,
      addAll: root.dataset.labelAddAll,
      addingAll: root.dataset.labelAddingAll,
      addedAll: root.dataset.labelAddedAll
    };
    const shopRoot = root.dataset.wishlistRoot || '/';
    const wishlistPage = root.dataset.wishlistPageUrl || '/pages/wishlist';
    const clearanceDiscountPercent = Math.max(0, Math.min(90, Number(root.dataset.clearanceDiscountPercent || 30)));
    const liveRegion = document.querySelector('.strobe-wishlist-live');
    let currentProduct = null;

    const productDataElement = root.querySelector('[data-wishlist-current-product]');
    if (productDataElement) {
      try {
        currentProduct = JSON.parse(productDataElement.textContent);
      } catch (error) {
        currentProduct = null;
      }
    }

    const heartIcon = () => `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"></path>
      </svg>`;

    const normalizeHandle = (value) => {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        const match = url.pathname.match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
      } catch (error) {
        return '';
      }
    };

    const getWishlist = () => {
      try {
        const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((item) => item && item.handle).slice(0, 100);
      } catch (error) {
        return [];
      }
    };

    const writeWishlist = (items, detail = {}) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, 100)));
      } catch (error) {
        return false;
      }
      window.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { items, ...detail }
      }));
      return true;
    };

    const findItem = (handle) => getWishlist().find((item) => item.handle === handle);
    const isInWishlist = (productIdOrHandle) => getWishlist().some((item) =>
      String(item.id) === String(productIdOrHandle) || item.handle === productIdOrHandle
    );

    const announce = (message) => {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      window.setTimeout(() => {
        liveRegion.textContent = message;
      }, 20);
    };

    const formatMoney = (cents, currency) => {
      const activeCurrency = currency || window.Shopify?.currency?.active || 'CAD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
          style: 'currency',
          currency: activeCurrency
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return `${(Number(cents || 0) / 100).toFixed(2)} ${activeCurrency}`;
      }
    };

    const fetchProduct = async (handle) => {
      const response = await fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    };

    const currentVariantId = () => {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      return productForm?.querySelector('[name="id"]')?.value || currentProduct?.selected_or_first_available_variant?.id || currentProduct?.variants?.[0]?.id || '';
    };

    const itemFromProduct = (product, variantId) => {
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const selectedVariant = variants.find((variant) => String(variant.id) === String(variantId))
        || variants.find((variant) => variant.available)
        || variants[0]
        || {};
      const featuredImage = selectedVariant.featured_image?.src
        || selectedVariant.featured_image
        || product.featured_image
        || product.images?.[0]
        || '';
      const basePrice = Number(selectedVariant.price ?? product.price ?? 0);
      const rawTags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
      const isClearance = rawTags.some((tag) => String(tag).trim().toLowerCase() === 'clearance');
      const clearancePrice = isClearance && clearanceDiscountPercent > 0
        ? Math.floor(basePrice * (100 - clearanceDiscountPercent) / 100)
        : basePrice;
      return {
        handle: product.handle,
        id: String(product.id),
        title: product.title,
        image: featuredImage,
        price: clearancePrice,
        originalPrice: isClearance ? basePrice : null,
        clearancePercent: isClearance ? clearanceDiscountPercent : 0,
        currency: window.Shopify?.currency?.active || 'CAD',
        variantId: selectedVariant.id ? String(selectedVariant.id) : '',
        variantTitle: selectedVariant.public_title || selectedVariant.title || '',
        available: selectedVariant.available !== false,
        url: `${shopRoot}products/${product.handle}`,
        addedAt: Date.now()
      };
    };

    const addToWishlist = async (productData) => {
      const product = productData?.handle
        ? productData
        : await fetchProduct(productData);
      const item = itemFromProduct(product, productData?.variantId || currentVariantId());
      const items = getWishlist().filter((saved) => saved.handle !== item.handle);
      items.unshift(item);
      if (writeWishlist(items, { action: 'add', item })) {
        announce(`${item.title}: ${labels.saved}`);
      }
      return item;
    };

    const addVariantsToCart = async (items) => {
      const cartItems = items
        .filter((item) => item?.id)
        .map((item) => ({
          id: String(item.id),
          quantity: Number(item.quantity) || 1
        }));
      if (!cartItems.length) throw new Error('Missing variants');
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: cartItems
        })
      });
      if (!response.ok) throw new Error('Cart add failed');
      const result = await response.json();
      document.dispatchEvent(new CustomEvent('strobe:wishlist-cart-added', {
        detail: { result, variantIds: cartItems.map((item) => item.id) }
      }));
      return result;
    };

    const addVariantToCart = (variantId, quantity = 1) =>
      addVariantsToCart([{ id: variantId, quantity }]);

    const updateWishlistItem = (handle, updates) => {
      let updated = null;
      const items = getWishlist().map((item) => {
        if (item.handle !== handle) return item;
        updated = { ...item, ...updates, handle, addedAt: item.addedAt };
        return updated;
      });
      if (updated) writeWishlist(items, { action: 'variant', item: updated });
      return updated;
    };

    const removeFromWishlist = (productIdOrHandle) => {
      const items = getWishlist();
      const removed = items.find((item) =>
        item.handle === productIdOrHandle || String(item.id) === String(productIdOrHandle)
      );
      const next = items.filter((item) =>
        item.handle !== productIdOrHandle && String(item.id) !== String(productIdOrHandle)
      );
      if (writeWishlist(next, { action: 'remove', item: removed })) {
        announce(removed ? `${removed.title}: ${labels.remove}` : labels.remove);
      }
      return removed;
    };

    const setHeartState = (button) => {
      const handle = button.dataset.productHandle;
      const saved = Boolean(findItem(handle));
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? `${labels.remove}: ${button.dataset.productTitle || ''}` : `${labels.add}: ${button.dataset.productTitle || ''}`);
      const text = button.querySelector('[data-wishlist-button-text]');
      if (text) text.textContent = saved ? labels.saved : labels.add;
      const view = button.parentElement?.querySelector('[data-wishlist-view-link]');
      if (view) view.hidden = !saved;
    };

    const updateAll = () => {
      document.querySelectorAll('.strobe-wishlist-heart, .strobe-wishlist-product-button').forEach(setHeartState);
      const count = getWishlist().length;
      document.querySelectorAll('[data-wishlist-count]').forEach((element) => {
        element.textContent = count > 99 ? '99+' : String(count);
        element.hidden = count === 0;
      });
      document.querySelectorAll('[data-wishlist-page-count]').forEach((element) => {
        element.textContent = String(count);
      });
    };

    const makeHeart = (handle, title, className = '') => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `strobe-wishlist-heart ${className}`.trim();
      button.dataset.productHandle = handle;
      button.dataset.productTitle = title || '';
      button.innerHTML = heartIcon();
      setHeartState(button);
      return button;
    };

    const injectCardHearts = (scope = document) => {
      const anchors = scope.querySelectorAll('a[href*="/products/"]');
      anchors.forEach((anchor) => {
        if (anchor.closest('[data-wishlist-grid], .product__info-container, .product__media-wrapper')) return;
        const handle = normalizeHandle(anchor.href);
        if (!handle) return;
        const card = anchor.closest('.card-wrapper, .strobe-product, .strobe-wishlist-suggestion, .product-card, li.grid__item, .grid__item');
        if (!card || card.querySelector(`.strobe-wishlist-card-heart[data-product-handle="${CSS.escape(handle)}"]`)) return;
        const title = card.querySelector('h3, .card__heading')?.textContent?.trim() || '';
        card.classList.add('strobe-wishlist-media-anchor');
        card.appendChild(makeHeart(handle, title, 'strobe-wishlist-card-heart'));
      });
    };

    const injectHeader = () => {
      document.querySelectorAll('.header__icons').forEach((icons) => {
        if (icons.querySelector('[data-strobe-wishlist-header]')) return;
        const link = document.createElement('a');
        link.href = wishlistPage;
        link.className = 'strobe-wishlist-header';
        link.dataset.strobeWishlistHeader = '';
        link.setAttribute('aria-label', labels.view);
        link.innerHTML = `${heartIcon()}<span class="strobe-wishlist-count" data-wishlist-count hidden>0</span>`;
        const cart = icons.querySelector('#cart-icon-bubble, .header__icon--cart');
        icons.insertBefore(link, cart || null);
      });
    };

    const injectProductButton = () => {
      if (!currentProduct || !currentProduct.handle) return;
      const container = document.querySelector('.product__info-container');
      if (!container || container.querySelector('.strobe-wishlist-product-button')) return;
      const actions = document.createElement('div');
      actions.className = 'strobe-wishlist-product-actions';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'strobe-wishlist-product-button';
      button.dataset.productHandle = currentProduct.handle;
      button.dataset.productTitle = currentProduct.title || '';
      button.innerHTML = `${heartIcon()}<span data-wishlist-button-text>${labels.add}</span>`;
      const view = document.createElement('a');
      view.href = wishlistPage;
      view.className = 'strobe-wishlist-product-view';
      view.dataset.wishlistViewLink = '';
      view.textContent = labels.view;
      actions.append(button, view);
      const share = container.querySelector('share-button, .product__share');
      container.insertBefore(actions, share || null);
      setHeartState(button);
    };

    const initWishlistHearts = (scope = document) => {
      injectHeader();
      injectCardHearts(scope);
      injectProductButton();
      updateAll();
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.strobe-wishlist-heart, .strobe-wishlist-product-button');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const handle = button.dataset.productHandle;
      if (!handle) return;
      button.disabled = true;
      try {
        if (isInWishlist(handle)) {
          removeFromWishlist(handle);
        } else if (currentProduct?.handle === handle) {
          await addToWishlist({ ...currentProduct, variantId: currentVariantId() });
        } else {
          await addToWishlist(handle);
        }
      } catch (error) {
        announce(labels.unavailable);
      } finally {
        button.disabled = false;
        updateAll();
      }
    }, true);

    document.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects, variant-radios, .product-form__input')) return;
      const saved = currentProduct?.handle ? findItem(currentProduct.handle) : null;
      if (!saved) return;
      window.setTimeout(async () => {
        try {
          const refreshed = itemFromProduct(currentProduct, currentVariantId());
          const items = getWishlist().map((item) => item.handle === refreshed.handle ? { ...item, ...refreshed, addedAt: item.addedAt } : item);
          writeWishlist(items, { action: 'variant', item: refreshed });
        } catch (error) {
          return;
        }
      }, 80);
    });

    window.addEventListener('wishlist:updated', updateAll);
    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY) updateAll();
    });
    document.addEventListener('shopify:section:load', (event) => initWishlistHearts(event.target));

    const observer = new MutationObserver((records) => {
      if (!records.some((record) => record.addedNodes.length)) return;
      window.requestAnimationFrame(() => injectCardHearts());
    });

    window.StrobeWishlist = {
      getWishlist,
      isInWishlist,
      addToWishlist,
      removeFromWishlist,
      addVariantToCart,
      addVariantsToCart,
      updateWishlistItem,
      initWishlistHearts,
      fetchProduct,
      itemFromProduct,
      formatMoney,
      labels,
      announce,
      shopRoot,
      wishlistPage
    };

    initWishlistHearts();
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-card-button-placement-fix"]) return;
  try {
    
  (() => {
    if (window.strobeCardButtonPlacementFixLoaded) return;
    window.strobeCardButtonPlacementFixLoaded = true;

    const getVisibleProductInformation = (card) => {
      const information = card.querySelector('.card > .card__content > .card__information');
      if (!information) return null;

      return information.querySelector(':scope > .card-information') || information;
    };

    const positionButtons = () => {
      const main = document.querySelector('#MainContent[data-template="collection"]');
      if (!main) return;

      main.querySelectorAll('.strobe-collection .card-wrapper').forEach((card) => {
        const purchase = card.querySelector('.strobe-card-purchase');
        const information = getVisibleProductInformation(card);
        if (!purchase || !information) return;

        purchase.hidden = false;
        purchase.removeAttribute('hidden');
        purchase.removeAttribute('inert');
        purchase.style.setProperty('display', 'block', 'important');
        purchase.style.setProperty('visibility', 'visible', 'important');
        purchase.style.setProperty('opacity', '1', 'important');
        purchase.style.setProperty('height', 'auto', 'important');

        const price = information.querySelector(':scope > .price') || information.querySelector('.price');

        if (price) {
          if (price.nextElementSibling !== purchase) price.after(purchase);
        } else if (purchase.parentElement !== information) {
          information.append(purchase);
        }
      });
    };

    const start = () => {
      const main = document.querySelector('#MainContent[data-template="collection"]');
      if (!main) return;

      positionButtons();

      let queued = false;
      const queuePosition = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          positionButtons();
        });
      };

      new MutationObserver(queuePosition).observe(main, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', queuePosition);
      document.addEventListener('shopify:section:reorder', queuePosition);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-cart-theme"]) return;
  try {
    
  (() => {
    if (window.strobeNativeCartLoaded) return;
    window.strobeNativeCartLoaded = true;

    const root = document.querySelector('.strobe-cart-theme');
    const liveStatus = document.querySelector('.strobe-cart-status');
    const shippingMessage = root?.dataset.shippingMessage
      || 'Shipping cost and delivery timing are shown before checkout.';

    const addShippingMessage = () => {
      const targets = new Set([
        ...document.querySelectorAll('.cart-notification__links'),
        ...document.querySelectorAll('.cart__footer .cart__ctas')
      ]);

      targets.forEach((target) => {
        if (!target || target.querySelector('.strobe-cart-shipping')) return;
        const message = document.createElement('p');
        message.className = 'strobe-cart-shipping';
        message.textContent = shippingMessage;
        target.prepend(message);
      });
    };

    const announceSuccess = (event) => {
      const itemCount = event?.cartData?.item_count;
      if (liveStatus) {
        liveStatus.textContent = Number.isFinite(itemCount)
          ? `Cart updated. ${itemCount} items in cart.`
          : 'Item added to cart.';
      }
      document.dispatchEvent(new CustomEvent('strobe:cart-add-success'));
      window.setTimeout(addShippingMessage, 40);
      window.setTimeout(addShippingMessage, 250);
    };

    const announceError = () => {
      if (liveStatus) liveStatus.textContent = 'The cart could not be updated. Please try again.';
      document.dispatchEvent(new CustomEvent('strobe:cart-add-error'));
    };

    const start = () => {
      addShippingMessage();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, announceSuccess);
        subscribe(PUB_SUB_EVENTS.cartError, announceError);
      }

      new MutationObserver(() => {
        window.requestAnimationFrame(addShippingMessage);
      }).observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-cart-view-fix"]) return;
  try {
    
  (() => {
    if (window.strobeCartViewFixLoaded) return;
    window.strobeCartViewFixLoaded = true;

    const rootSelector = [
      'cart-drawer',
      '#CartDrawer',
      '.cart-drawer',
      '[data-cart-drawer]',
      '[class*="slide-cart"]',
      '[id*="slide-cart"]',
      '[class*="kaktus"]',
      '[id*="kaktus"]',
      '[role="dialog"][aria-label*="cart" i]'
    ].join(',');

    const explicitOpenSelector = [
      'cart-drawer.active',
      'cart-drawer.is-open',
      'cart-drawer[open]',
      '#CartDrawer[aria-hidden="false"]',
      '[data-cart-drawer][aria-hidden="false"]',
      '[role="dialog"][aria-label*="cart" i][aria-hidden="false"]'
    ].join(',');

    let markedRoots = new Set();
    let updateScheduled = false;

    const isVisibleInViewport = (element) => {
      if (!(element instanceof HTMLElement)) return false;

      const styles = getComputedStyle(element);
      if (
        styles.display === 'none'
        || styles.visibility === 'hidden'
        || Number(styles.opacity) === 0
      ) {
        return false;
      }

      const rect = element.getBoundingClientRect();
      return (
        rect.width > 0
        && rect.height > 0
        && rect.right > 0
        && rect.bottom > 0
        && rect.left < window.innerWidth
        && rect.top < window.innerHeight
      );
    };

    const hasOpenSignal = (element) => {
      const className = typeof element.className === 'string' ? element.className : '';
      return (
        element.matches(explicitOpenSelector)
        || element.hasAttribute('open')
        || element.getAttribute('aria-hidden') === 'false'
        || element.getAttribute('aria-expanded') === 'true'
        || /(^|\s|--|_)(active|open|opened|visible|show|shown)(\s|$|--|_)/i.test(className)
      );
    };

    const findPanelFromHeading = (heading) => {
      let current = heading;
      for (let level = 0; current && level < 9; level += 1) {
        if (current instanceof HTMLElement) {
          const styles = getComputedStyle(current);
          if (
            current.matches(rootSelector)
            || current.getAttribute('role') === 'dialog'
            || styles.position === 'fixed'
          ) {
            return current;
          }
        }
        current = current.parentElement;
      }
      return null;
    };

    const findOpenCartRoots = () => {
      const openRoots = new Set();

      document.querySelectorAll(rootSelector).forEach((element) => {
        if (isVisibleInViewport(element) && hasOpenSignal(element)) {
          openRoots.add(element);
        }
      });

      document.querySelectorAll('h1, h2, h3, [role="heading"]').forEach((heading) => {
        const text = heading.textContent.trim().replace(/\s+/g, ' ');
        if (!/^(your cart|shopping cart|cart)(\s|$)/i.test(text)) return;
        if (!isVisibleInViewport(heading)) return;

        const panel = findPanelFromHeading(heading);
        if (panel && isVisibleInViewport(panel)) openRoots.add(panel);
      });

      return openRoots;
    };

    const syncCartState = () => {
      updateScheduled = false;
      const openRoots = findOpenCartRoots();

      markedRoots.forEach((element) => {
        if (!openRoots.has(element)) {
          element.removeAttribute('data-strobe-cart-open-root');
        }
      });

      openRoots.forEach((element) => {
        element.setAttribute('data-strobe-cart-open-root', 'true');
      });

      markedRoots = openRoots;
      const isOpen = openRoots.size > 0;
      document.documentElement.classList.toggle('strobe-cart-drawer-open', isOpen);

      if (isOpen && document.activeElement?.closest?.('.strobe-cookie-consent')) {
        document.activeElement.blur();
      }

      document.dispatchEvent(
        new CustomEvent('strobe:cart-visibility-change', { detail: { open: isOpen } })
      );
    };

    const scheduleSync = () => {
      if (updateScheduled) return;
      updateScheduled = true;
      requestAnimationFrame(syncCartState);
    };

    const start = () => {
      scheduleSync();

      new MutationObserver(scheduleSync).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'aria-expanded'],
        childList: true,
        subtree: true
      });

      document.addEventListener('click', () => {
        scheduleSync();
        window.setTimeout(scheduleSync, 80);
        window.setTimeout(scheduleSync, 350);
      }, true);

      document.addEventListener('strobe:cart-add-success', scheduleSync);
      window.addEventListener('resize', scheduleSync);
      window.visualViewport?.addEventListener('resize', scheduleSync);
      window.visualViewport?.addEventListener('scroll', scheduleSync);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-collection"]) return;
  try {
    
  (() => {
    const selector = '.strobe-collection__hero h1';

    const fitTitle = (title) => {
      if (window.innerWidth > 749) {
        title.classList.remove('is-fitting');
        title.style.removeProperty('font-size');
        return;
      }

      title.classList.add('is-fitting');
      title.style.removeProperty('font-size');

      let size = Number.parseFloat(window.getComputedStyle(title).fontSize);
      const minimumSize = 22;

      while (size > minimumSize) {
        const styles = window.getComputedStyle(title);
        const lineHeight = Number.parseFloat(styles.lineHeight);

        if (title.scrollHeight <= lineHeight * 2 + 1) break;

        size -= 1;
        title.style.fontSize = `${size}px`;
      }

      title.classList.remove('is-fitting');
    };

    const fitAllTitles = () => {
      document.querySelectorAll(selector).forEach(fitTitle);
    };

    let resizeFrame;
    const queueFit = () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(fitAllTitles);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fitAllTitles, { once: true });
    } else {
      fitAllTitles();
    }

    window.addEventListener('resize', queueFit, { passive: true });
    document.addEventListener('shopify:section:load', queueFit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-conversion-fixes"]) return;
  try {
    
  (() => {
    if (window.strobeConversionFixesLoaded) return;
    window.strobeConversionFixesLoaded = true;

    const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;
    const thirdPartySelector = [
      '[class*="slide-cart-drawer"]',
      '[id*="slide-cart-drawer"]',
      '[class*="kaktus"][class*="cart"]',
      '[id*="kaktus"][id*="cart"]'
    ].join(',');

    const neutralizeThirdPartyCart = () => {
      document.querySelectorAll(thirdPartySelector).forEach((element) => {
        if (element === document.body || element === document.documentElement) return;
        if (element.closest('cart-notification, .cart-notification')) return;
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('inert', '');
        element.style.setProperty('display', 'none', 'important');
      });

      if (document.body) {
        Array.from(document.body.classList).forEach((className) => {
          if (/slide.?cart|kaktus/i.test(className)) document.body.classList.remove(className);
        });
        if (getComputedStyle(document.body).overflow === 'hidden') {
          document.body.style.removeProperty('overflow');
        }
      }
    };

    const forceFullCart = (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const link = target?.closest(
        '#cart-icon-bubble, a.header__icon--cart[href*="/cart"], a[href="/cart"][aria-label*="cart" i]'
      );
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.assign(cartUrl);
    };

    const hardenSizeSelection = (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const label = target?.closest(
        '.strobe-size-field label[for], .product-form__input--pill label[for]'
      );
      if (!label) return;

      const input = document.getElementById(label.htmlFor);
      if (!(input instanceof HTMLInputElement) || input.disabled) return;

      window.setTimeout(() => {
        if (input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 0);
    };

    const createMenuItem = (mobile = false) => {
      const item = document.createElement('li');
      item.className = 'strobe-direct-hoodies-link';
      const link = document.createElement('a');
      link.href = '/collections/hoodies-jackets';
      link.textContent = 'HOODIES';
      link.className = mobile
        ? 'menu-drawer__menu-item list-menu__item link link--text focus-inset'
        : 'header__menu-item list-menu__item link link--text focus-inset';
      item.append(link);
      return item;
    };

    const addDirectHoodieNavigation = () => {
      const desktop = document.querySelector('.header__inline-menu');
      if (desktop && !desktop.querySelector(':scope > .strobe-direct-hoodies-link')) {
        const existingDirect = Array.from(desktop.children).some((item) =>
          item.querySelector(':scope > a[href="/collections/hoodies-jackets"]')
        );
        if (!existingDirect) desktop.append(createMenuItem(false));
      }

      document.querySelectorAll('.menu-drawer__menu').forEach((menu) => {
        if (menu.closest('.menu-drawer__submenu')) return;
        if (menu.querySelector(':scope > .strobe-direct-hoodies-link')) return;
        const existingDirect = Array.from(menu.children).some((item) =>
          item.querySelector(':scope > a[href="/collections/hoodies-jackets"]')
        );
        if (!existingDirect) menu.append(createMenuItem(true));
      });
    };

    const compactCookieCopy = () => {
      const cookie = document.querySelector('[data-strobe-cookie-consent]');
      if (!cookie) return;
      const heading = cookie.querySelector('.strobe-cookie-consent__copy > strong');
      const paragraph = cookie.querySelector('.strobe-cookie-consent__copy > p');
      if (heading) heading.textContent = 'Privacy choices';
      if (paragraph && paragraph.dataset.strobeCompact !== 'true') {
        const policyLink = paragraph.querySelector('a')?.cloneNode(true);
        paragraph.textContent = 'Essential cookies keep the store working. Choose whether to allow optional analytics and marketing. ';
        if (policyLink) paragraph.append(policyLink);
        paragraph.dataset.strobeCompact = 'true';
      }
    };

    const start = () => {
      if (document.querySelector('.product')) document.body.classList.add('strobe-product-page');
      neutralizeThirdPartyCart();
      addDirectHoodieNavigation();
      compactCookieCopy();

      document.addEventListener('click', forceFullCart, true);
      document.addEventListener('click', hardenSizeSelection, true);

      let scheduled = false;
      const scheduleRefresh = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          neutralizeThirdPartyCart();
          addDirectHoodieNavigation();
          compactCookieCopy();
        });
      };

      new MutationObserver(scheduleRefresh).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-cookie-theme"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-strobe-cookie-consent]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const summary = root.querySelector('[data-cookie-summary]');
    const preferences = root.querySelector('[data-cookie-preferences]');
    const status = root.querySelector('[data-cookie-status]');
    const saleRow = root.querySelector('[data-cookie-sale-row]');
    const settings = {
      analytics: root.querySelector('[data-cookie-setting="analytics"]'),
      marketing: root.querySelector('[data-cookie-setting="marketing"]'),
      preferences: root.querySelector('[data-cookie-setting="preferences"]'),
      saleOptOut: root.querySelector('[data-cookie-setting="sale-opt-out"]')
    };

    const avadaSelector = [
      '#avada-cookie-consent',
      '#avada-cookie-bar',
      '#avada-cookie-modal',
      '.avada-cookie-consent',
      '.avada-cookie-bar',
      '.avada-cookie-modal',
      '.avada-modal-overlay',
      '[data-avada-cookie]',
      '[class*="avada"][class*="cookie"]',
      '[class*="avada"][class*="overlay"]',
      'iframe[src*="avada"][src*="cookie"]'
    ].join(',');

    let privacy = null;
    let bannerRequired = false;
    let openedFromFooter = false;
    let resizeObserver = null;

    const updatePageSpace = () => {
      if (root.hidden) {
        document.body.classList.remove('strobe-cookie-visible');
        document.documentElement.style.removeProperty('--strobe-cookie-space');
        return;
      }

      const space = Math.ceil(root.getBoundingClientRect().height + 20);
      document.documentElement.style.setProperty('--strobe-cookie-space', `${space}px`);
      document.body.classList.add('strobe-cookie-visible');
    };

    const showRoot = () => {
      root.hidden = false;
      requestAnimationFrame(updatePageSpace);
    };

    const hideRoot = () => {
      root.hidden = true;
      openedFromFooter = false;
      updatePageSpace();
    };

    const showSummary = () => {
      summary.hidden = false;
      preferences.hidden = true;
      showRoot();
      root.querySelector('[data-cookie-action="accept"]')?.focus({ preventScroll: true });
    };

    const getConsent = () => {
      try {
        return privacy?.currentVisitorConsent?.() || {};
      } catch (error) {
        return {};
      }
    };

    const showPreferences = (fromFooter = false) => {
      if (!privacy) return;
      openedFromFooter = fromFooter;

      const consent = getConsent();
      settings.analytics.checked = consent.analytics === 'yes';
      settings.marketing.checked = consent.marketing === 'yes';
      settings.preferences.checked = consent.preferences === 'yes';

      const isSaleRegion = Boolean(privacy.saleOfDataRegion?.());
      saleRow.hidden = !isSaleRegion;
      settings.saleOptOut.checked = consent.sale_of_data === 'no';

      summary.hidden = true;
      preferences.hidden = false;
      status.textContent = '';
      showRoot();
      settings.analytics.focus({ preventScroll: true });
    };

    const suppressAvada = () => {
      let found = false;
      document.querySelectorAll(avadaSelector).forEach((element) => {
        found = true;
        element.setAttribute('aria-hidden', 'true');
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      });

      if (found) {
        document.body.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('overflow');
      }
    };

    const saveConsent = (payload) => {
      if (!privacy?.setTrackingConsent) return;

      status.textContent = 'Saving…';
      privacy.setTrackingConsent(payload, (result) => {
        if (result?.error) {
          status.textContent = 'We could not save your choices. Please try again.';
          return;
        }

        status.textContent = 'Saved.';
        bannerRequired = false;
        window.setTimeout(hideRoot, 250);
      });
    };

    const injectFooterLink = () => {
      if (document.querySelector('[data-strobe-cookie-footer-link]')) return;

      const footerTarget = document.querySelector('.footer__copyright');
      if (!footerTarget) return;

      const wrapper = document.createElement('small');
      wrapper.className = 'copyright__content';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'strobe-cookie-footer-link';
      button.dataset.strobeCookieFooterLink = 'true';
      button.textContent = 'Cookie preferences';
      button.addEventListener('click', () => showPreferences(true));

      wrapper.appendChild(button);
      footerTarget.appendChild(wrapper);
    };

    root.addEventListener('click', (event) => {
      const action = event.target.closest('[data-cookie-action]')?.dataset.cookieAction;
      if (!action) return;

      if (action === 'accept') {
        saveConsent({ analytics: true, marketing: true, preferences: true });
      }

      if (action === 'essential') {
        saveConsent({ analytics: false, marketing: false, preferences: false });
      }

      if (action === 'preferences') {
        showPreferences(false);
      }

      if (action === 'save') {
        const payload = {
          analytics: settings.analytics.checked,
          marketing: settings.marketing.checked,
          preferences: settings.preferences.checked
        };

        if (!saleRow.hidden) {
          payload.sale_of_data = !settings.saleOptOut.checked;
        }

        saveConsent(payload);
      }

      if (action === 'back') {
        if (bannerRequired && !openedFromFooter) {
          showSummary();
        } else {
          hideRoot();
        }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || root.hidden) return;

      if (!preferences.hidden && bannerRequired && !openedFromFooter) {
        showSummary();
      } else if (!bannerRequired || openedFromFooter) {
        hideRoot();
      }
    });

    const initializePrivacy = (attempt = 0) => {
      if (!window.Shopify?.loadFeatures) {
        if (attempt < 50) window.setTimeout(() => initializePrivacy(attempt + 1), 100);
        return;
      }

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error || !window.Shopify.customerPrivacy) return;

          privacy = window.Shopify.customerPrivacy;
          document.documentElement.classList.add('strobe-cookie-replacement-ready');
          suppressAvada();
          injectFooterLink();

          const avadaObserver = new MutationObserver(suppressAvada);
          avadaObserver.observe(document.documentElement, { childList: true, subtree: true });

          bannerRequired = Boolean(privacy.shouldShowBanner?.());
          if (bannerRequired) showSummary();
        }
      );
    };

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(updatePageSpace);
      resizeObserver.observe(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        injectFooterLink();
        initializePrivacy();
      }, { once: true });
    } else {
      injectFooterLink();
      initializePrivacy();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-critical-product-fixes"]) return;
  try {
    
  (() => {
    const initializeProductDetails = () => {
      const root = document.querySelector('[data-strobe-product-details]');
      if (!root || root.dataset.accordionsReady === 'true') return;
      root.dataset.accordionsReady = 'true';

      root.querySelectorAll('.strobe-product-details__item').forEach((details, index) => {
        const summary = details.querySelector(':scope > summary');
        const content = details.querySelector(':scope > .strobe-product-details__content');
        if (!summary || !content) return;

        if (!content.id) content.id = `strobe-product-detail-content-${index + 1}`;
        summary.setAttribute('aria-controls', content.id);

        const syncState = () => {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          content.setAttribute('aria-hidden', details.open ? 'false' : 'true');
        };

        syncState();
        details.addEventListener('toggle', syncState);
      });

      document.querySelectorAll('a[href^="#strobe-materials-fit-care"], a[href^="#strobe-product-size-guide"]').forEach((link) => {
        link.addEventListener('click', () => {
          const target = document.querySelector(link.getAttribute('href'));
          if (!(target instanceof HTMLDetailsElement)) return;
          target.open = true;
          const summary = target.querySelector(':scope > summary');
          summary?.setAttribute('aria-expanded', 'true');
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProductDetails, { once: true });
    } else {
      initializeProductDetails();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-editorial-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-bandcamp-click]');
    if (!link) return;
    if (window.strobeAnalyticsExcluded) return;

    const analyticsParameters = {
      release_title: link.dataset.releaseTitle || '',
      click_location: link.dataset.clickLocation || '',
      destination_url: link.href
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'bandcamp_purchase_click', analyticsParameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bandcamp_purchase_click',
        ...analyticsParameters
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-home-music-row-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sourceSelector = '[data-strobe-home-music-row-2-source]';
    const mountSelector = '[data-strobe-home-music-row-2-mounted]';

    const removeMountedRow = (sectionId) => {
      if (!sectionId) return;

      document.querySelectorAll(mountSelector).forEach((node) => {
        if (node.dataset.strobeHomeMusicRow2Mounted === sectionId) {
          node.remove();
        }
      });
    };

    const mountMusicRow = (source) => {
      const target = document.querySelector('.strobe-releases');
      if (!source || !target) return;

      const sectionId = source.dataset.sectionId || '';
      removeMountedRow(sectionId);

      const mount = document.createElement('div');
      mount.className = 'strobe-home-music-row-2__mount';
      mount.dataset.strobeHomeMusicRow2Mounted = sectionId;

      Array.from(source.children).forEach((card) => {
        mount.appendChild(card.cloneNode(true));
      });

      target.appendChild(mount);
    };

    const mountAllMusicRows = () => {
      document.querySelectorAll(sourceSelector).forEach(mountMusicRow);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountAllMusicRows, { once: true });
    } else {
      mountAllMusicRows();
    }

    document.addEventListener('shopify:section:load', mountAllMusicRows);
    document.addEventListener('shopify:section:reorder', mountAllMusicRows);
    document.addEventListener('shopify:section:unload', (event) => {
      const source = event.target && event.target.querySelector
        ? event.target.querySelector(sourceSelector)
        : null;
      removeMountedRow(source ? source.dataset.sectionId : event.detail && event.detail.sectionId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-mixtape"]) return;
  try {
    
  (() => {
    const formatTime = (seconds) => {
      if (!Number.isFinite(seconds)) return '--:--';
      return `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
    };

    const initialize = (player) => {
      if (player.dataset.initialized === 'true') return;
      player.dataset.initialized = 'true';
      const audio = player.querySelector('audio');
      const toggle = player.querySelector('[data-player-toggle]');
      const icon = player.querySelector('[data-player-icon]');
      const seek = player.querySelector('[data-player-seek]');
      const current = player.querySelector('[data-player-current]');
      const duration = player.querySelector('[data-player-duration]');
      if (!audio || !toggle || !seek) return;

      const sync = () => {
        seek.value = String(Math.round((audio.duration ? audio.currentTime / audio.duration : 0) * 1000));
        current.textContent = formatTime(audio.currentTime);
        duration.textContent = formatTime(audio.duration);
      };

      toggle.addEventListener('click', () => audio.paused ? audio.play() : audio.pause());
      seek.addEventListener('input', () => {
        if (audio.duration) audio.currentTime = Number(seek.value) / 1000 * audio.duration;
      });
      audio.addEventListener('loadedmetadata', sync);
      audio.addEventListener('timeupdate', sync);
      audio.addEventListener('play', () => {
        icon.textContent = '❚❚';
        toggle.setAttribute('aria-label', 'Pause mixtape');
      });
      audio.addEventListener('pause', () => {
        icon.textContent = '▶';
        toggle.setAttribute('aria-label', 'Play mixtape');
      });
    };

    const initializeAll = (root = document) => root.querySelectorAll('[data-mixtape-player]').forEach(initialize);
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-mixtapes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatTime = (seconds) => {
      if (!Number.isFinite(seconds)) return '--:--';
      const minutes = Math.floor(seconds / 60);
      const remainder = Math.floor(seconds % 60);
      return `${minutes}:${String(remainder).padStart(2, '0')}`;
    };

    const pauseOtherPlayers = (activeAudio) => {
      document.querySelectorAll('[data-mixtape-player] audio').forEach((audio) => {
        if (audio !== activeAudio && !audio.paused) audio.pause();
      });
    };

    const initializePlayer = (player) => {
      if (player.dataset.initialized === 'true') return;
      player.dataset.initialized = 'true';

      const audio = player.querySelector('audio');
      const toggle = player.querySelector('[data-player-toggle]');
      const icon = player.querySelector('[data-player-icon]');
      const seek = player.querySelector('[data-player-seek]');
      const current = player.querySelector('[data-player-current]');
      const duration = player.querySelector('[data-player-duration]');

      if (!audio || !toggle || !seek) return;

      const sync = () => {
        const ratio = audio.duration ? audio.currentTime / audio.duration : 0;
        seek.value = String(Math.round(ratio * 1000));
        current.textContent = formatTime(audio.currentTime);
        duration.textContent = formatTime(audio.duration);
      };

      toggle.addEventListener('click', () => {
        if (audio.paused) {
          pauseOtherPlayers(audio);
          audio.play();
        } else {
          audio.pause();
        }
      });

      seek.addEventListener('input', () => {
        if (audio.duration) audio.currentTime = (Number(seek.value) / 1000) * audio.duration;
      });

      audio.addEventListener('loadedmetadata', sync);
      audio.addEventListener('timeupdate', sync);
      audio.addEventListener('play', () => {
        icon.textContent = '❚❚';
        toggle.setAttribute('aria-label', 'Pause mixtape');
      });
      audio.addEventListener('pause', () => {
        icon.textContent = '▶';
        toggle.setAttribute('aria-label', 'Play mixtape');
      });
      audio.addEventListener('ended', sync);
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-mixtape-player]').forEach(initializePlayer);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-music-catalogue"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-bandcamp-click]');
    if (!link) return;
    if (window.strobeAnalyticsExcluded) return;

    const analyticsParameters = {
      release_title: link.dataset.releaseTitle || '',
      release_handle: link.dataset.releaseHandle || '',
      click_location: link.dataset.clickLocation || '',
      destination_url: link.href
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'bandcamp_purchase_click', analyticsParameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bandcamp_purchase_click',
        ...analyticsParameters
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-music-tiles"] && !Shopify.designMode) return;
  try {
    
  function updateMusicReleaseCount() {
    const count = document.querySelectorAll('.strobe-music-catalogue .strobe-release-card').length;
    document.querySelectorAll('[data-music-release-count]').forEach(element => { element.textContent = count; });
  }
  updateMusicReleaseCount();
  document.addEventListener('shopify:section:load', updateMusicReleaseCount);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updateMusicReleaseCount));
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-bandcamp-click]');
    if (!link) return;
    if (window.strobeAnalyticsExcluded) return;

    const analyticsParameters = {
      release_title: link.dataset.releaseTitle || '',
      release_handle: link.dataset.releaseHandle || '',
      click_location: link.dataset.clickLocation || '',
      destination_url: link.href
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'bandcamp_purchase_click', analyticsParameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bandcamp_purchase_click',
        ...analyticsParameters
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-product-buy-button-lock"]) return;
  try {
    
  (() => {
    if (window.strobePurchaseButtonLockLoaded) return;
    window.strobePurchaseButtonLockLoaded = true;

    const revealProductPurchaseControls = () => {
      const main = document.querySelector('#MainContent[data-template="product"]');
      if (!main) return;

      const containerSelector = [
        '.product__info-container .product-form',
        '.product__info-container .product-form > form',
        '.product__info-container .product-form__buttons',
        '.single-product-add-to-cart-btns',
        '.single-album-add-to-cart'
      ].join(',');
      const buttonSelector = [
        '.product__info-container .product-form__submit',
        '.single-product-add-to-cart-btns button[name="add"]',
        '.single-album-add-to-cart button[name="add"]'
      ].join(',');

      main.querySelectorAll(containerSelector).forEach((element) => {
        element.hidden = false;
        element.removeAttribute('hidden');
        element.removeAttribute('inert');
        element.style.setProperty('display', 'block', 'important');
        element.style.setProperty('visibility', 'visible', 'important');
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('height', 'auto', 'important');
        element.style.setProperty('max-height', 'none', 'important');
        element.style.setProperty('overflow', 'visible', 'important');
      });

      main.querySelectorAll(buttonSelector).forEach((button) => {
        button.hidden = false;
        button.removeAttribute('hidden');
        button.removeAttribute('inert');
        button.style.setProperty('display', 'flex', 'important');
        button.style.setProperty('visibility', 'visible', 'important');
        button.style.setProperty('width', '100%', 'important');
        button.style.setProperty('min-height', '56px', 'important');

        const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
        button.style.setProperty('opacity', disabled ? '.65' : '1', 'important');
        button.style.setProperty('color', disabled ? '#d0d0d0' : '#ffffff', 'important');
        button.style.setProperty('background', disabled ? '#383838' : '#e32618', 'important');
        button.style.setProperty('border-color', disabled ? '#383838' : '#e32618', 'important');
      });
    };

    const getCollectionProductData = () => {
      const dataElement = document.querySelector('script[id^="StrobeCollectionPurchaseData-"]');
      if (!dataElement) return {};
      try {
        return JSON.parse(dataElement.textContent || '{}');
      } catch (error) {
        console.error('Unable to load collection purchase data.', error);
        return {};
      }
    };

    const getProductHandle = (card) => {
      const link = card.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"]');
      if (!link) return '';
      try {
        const url = new URL(link.href, window.location.origin);
        const match = url.pathname.match(/\/products\/([^/]+)/);
        return match ? decodeURIComponent(match[1]) : '';
      } catch (error) {
        return '';
      }
    };

    const updateCartBubble = async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        const cartLink = document.querySelector('#cart-icon-bubble, a.header__icon--cart[href*="/cart"]');
        if (!cartLink) return;

        let bubble = cartLink.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          cartLink.append(bubble);
        }
        bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>`;
      } catch (error) {
        return;
      }
    };

    const createDirectAddForm = (productData) => {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = window.routes?.cart_add_url || '/cart/add';
      form.enctype = 'multipart/form-data';
      form.dataset.type = 'add-to-cart-form';

      const variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'id';
      variantInput.value = String(productData.variantId || '');

      const quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';

      const button = document.createElement('button');
      button.type = 'submit';
      button.name = 'add';
      button.className = 'strobe-card-purchase__button';
      button.innerHTML = '<span>ADD TO CART</span>';

      form.append(variantInput, quantityInput, button);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled) return;

        const label = button.querySelector('span');
        button.disabled = true;
        if (label) label.textContent = 'ADDING…';

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok || result.status) throw new Error(result.description || 'Unable to add item.');

          if (label) label.textContent = 'ADDED TO CART';
          await updateCartBubble();
          document.dispatchEvent(new CustomEvent('strobe:cart-add-success', { detail: result }));
          window.setTimeout(() => {
            button.disabled = false;
            if (label) label.textContent = 'ADD TO CART';
          }, 1600);
        } catch (error) {
          button.disabled = false;
          if (label) label.textContent = 'TRY AGAIN';
          document.dispatchEvent(new CustomEvent('strobe:cart-add-error', { detail: { message: error.message } }));
          window.setTimeout(() => {
            if (label) label.textContent = 'ADD TO CART';
          }, 2200);
        }
      });

      return form;
    };

    const injectCollectionPurchaseButtons = () => {
      const main = document.querySelector('#MainContent[data-template="collection"]');
      if (!main) return;
      const productData = getCollectionProductData();

      main.querySelectorAll('.strobe-collection .card-wrapper.product-card-wrapper, .strobe-collection .card-wrapper').forEach((card) => {
        if (card.querySelector('.strobe-card-purchase')) return;

        const handle = getProductHandle(card);
        if (!handle) return;
        const data = productData[handle] || null;
        const productLink = card.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"]');
        const content = card.querySelector('.card__content') || card;
        const purchase = document.createElement('div');
        purchase.className = 'strobe-card-purchase';

        if (data && data.available === false) {
          const soldOut = document.createElement('button');
          soldOut.type = 'button';
          soldOut.className = 'strobe-card-purchase__button';
          soldOut.textContent = 'SOLD OUT';
          soldOut.disabled = true;
          purchase.append(soldOut);
        } else if (data && data.hasOnlyDefaultVariant && data.variantId) {
          purchase.append(createDirectAddForm(data));
        } else {
          const chooseOptions = document.createElement('a');
          chooseOptions.className = 'strobe-card-purchase__button';
          chooseOptions.href = data?.url || productLink?.href || `/products/${encodeURIComponent(handle)}`;
          chooseOptions.textContent = 'CHOOSE OPTIONS';
          purchase.append(chooseOptions);
        }

        content.append(purchase);
      });
    };

    const startProductSafeguard = () => {
      const main = document.querySelector('#MainContent[data-template="product"]');
      if (!main) return;
      revealProductPurchaseControls();
      let queued = false;
      const queueReveal = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          revealProductPurchaseControls();
        });
      };
      new MutationObserver(queueReveal).observe(main, { childList: true, subtree: true });
      document.addEventListener('change', queueReveal);
      document.addEventListener('shopify:section:load', queueReveal);
    };

    const startCollectionButtons = () => {
      const main = document.querySelector('#MainContent[data-template="collection"]');
      if (!main) return;
      injectCollectionPurchaseButtons();
      let queued = false;
      const queueInjection = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          injectCollectionPurchaseButtons();
        });
      };
      new MutationObserver(queueInjection).observe(main, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', queueInjection);
    };

    const start = () => {
      startProductSafeguard();
      startCollectionButtons();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-product-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeHtml = (html) => html
      .replace(/This product is made especially for you as soon as you place an order[\s\S]*?thoughtful purchasing decisions!/gi, '')
      .replace(/Age restrictions:[\s\S]*$/gi, '')
      .replace(/In compliance with the General Product Safety Regulation[\s\S]*$/gi, '')
      .replace(/(<br\s*\/?>\s*){3,}/gi, '<br><br>')
      .trim();

    document.querySelectorAll('[data-strobe-product-details]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const source = root.querySelector('[data-product-description-source]');
      const materialsTarget = root.querySelector('[data-materials-target]');
      const sizeTarget = root.querySelector('[data-size-target]');
      const shippingTarget = root.querySelector('[data-shipping-target]');
      if (!source || !materialsTarget) return;

      const sourceDocument = document.createElement('div');
      sourceDocument.innerHTML = source.innerHTML;
      const sourceText = sourceDocument.textContent.replace(/\s+/g, ' ').trim();
      const madeToOrder = /made especially for you as soon as you place an order/i.test(sourceText);

      const materialDetails = Array.from(sourceDocument.querySelectorAll('details')).find((details) =>
        /materials?.*fit|fit.*care|materials?/i.test(details.querySelector('summary')?.textContent || '')
      );
      const materialSource = materialDetails?.querySelector('.strobe-product-copy__details')
        || materialDetails
        || sourceDocument;
      const materialClone = materialSource.cloneNode(true);

      materialClone.querySelectorAll('summary').forEach((summary) => summary.remove());
      materialClone.querySelectorAll('details').forEach((details) => details.replaceWith(...details.childNodes));
      materialClone.querySelectorAll('.size-guide-title').forEach((title) => {
        const wrapper = title.closest('p') || title;
        wrapper.remove();
      });
      materialClone.querySelectorAll('.table-responsive, table#size-guide').forEach((table) => table.remove());

      const materialHtml = normalizeHtml(materialClone.innerHTML);
      if (materialHtml && materialClone.textContent.replace(/\s+/g, ' ').trim()) {
        materialsTarget.innerHTML = materialHtml;
      } else {
        materialsTarget.innerHTML = '<p>Exact fibre content and construction can vary by style, colour or production run. Check the garment label or contact customer support before ordering if you need the current composition for a specific option.</p>';
      }

      if (sizeTarget) {
        const fitMessage = document.createElement('p');
        if (/runs small/i.test(sourceText)) {
          fitMessage.innerHTML = '<strong>This style runs small.</strong> Consider ordering one size larger than your usual size, then confirm your choice against the measurements below.';
        } else if (/relaxed fit/i.test(sourceText)) {
          fitMessage.innerHTML = '<strong>Relaxed fit.</strong> Choose your usual size for the intended fit and confirm your choice against the measurements below.';
        } else if (/cropped/i.test(sourceText)) {
          fitMessage.innerHTML = '<strong>Cropped silhouette.</strong> Review both width and length before choosing a size.';
        } else {
          fitMessage.textContent = 'Use the product-specific garment measurements below. Compare them with a similar item you already own for the most reliable fit.';
        }
        sizeTarget.innerHTML = '';
        sizeTarget.append(fitMessage);

        const wrappers = Array.from(sourceDocument.querySelectorAll('.table-responsive'));
        wrappers.forEach((wrapper) => sizeTarget.append(wrapper.cloneNode(true)));
        sourceDocument.querySelectorAll('table#size-guide').forEach((table) => {
          if (!table.closest('.table-responsive')) {
            const responsive = document.createElement('div');
            responsive.className = 'table-responsive';
            responsive.append(table.cloneNode(true));
            sizeTarget.append(responsive);
          }
        });

        if (!sizeTarget.querySelector('table')) {
          const help = document.createElement('p');
          help.textContent = 'A measurement table is not available for this item. Contact customer support before ordering if you need help choosing a size.';
          sizeTarget.append(help);
        }
      }

      if (madeToOrder && shippingTarget && !shippingTarget.querySelector('.strobe-product-details__production-note')) {
        const note = document.createElement('div');
        note.className = 'strobe-product-details__production-note';
        note.innerHTML = '<strong>Made to order</strong><p>This item is produced after your order is placed rather than held in bulk inventory. Production time is included in the delivery estimate shown before checkout. This is a product purchase—not a membership or subscription.</p>';
        shippingTarget.prepend(note);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-product-theme"]) return;
  try {
    
  (() => {
    const productRoot = document.querySelector('.product');
    if (!productRoot) return;
    const productTheme = document.querySelector('.strobe-product-theme');
    const productInfo = productRoot.querySelector('.product__info-container');
    const reviewSummary = document.querySelector('[data-strobe-review-summary]');
    const reviewStatus = reviewSummary?.querySelector('[data-strobe-review-status]');
    const reviewAnchor = document.querySelector('#strobe-product-reviews');
    const reviewSection = reviewAnchor?.closest('.shopify-section')?.nextElementSibling;

    const gallery = productRoot.querySelector('media-gallery');
    const mediaList = gallery?.querySelector('.product__media-list');
    let galleryFilterTimer;
    const fallbackGalleryMedia = {
      'strobe-records-35th-anniversary-classic-unisex-hoodie': [
        {
          view: 'back',
          url: 'https://cdn.shopify.com/s/files/1/0570/4191/1877/files/cotton-heritage-m2580-i-unisex-premium-pullover-hoodie-black-back-692548a551887.jpg?v=1764051134'
        },
        {
          view: 'left',
          url: 'https://cdn.shopify.com/s/files/1/0570/4191/1877/files/cotton-heritage-m2580-i-unisex-premium-pullover-hoodie-black-left-692548a54f3f4.jpg?v=1764051133'
        },
        {
          view: 'right',
          url: 'https://cdn.shopify.com/s/files/1/0570/4191/1877/files/cotton-heritage-m2580-i-unisex-premium-pullover-hoodie-black-right-692548a550770.jpg?v=1764051133'
        }
      ]
    };

    const mediaSource = (item) => {
      if (item.dataset.strobeSourceUrl) return item.dataset.strobeSourceUrl;
      const image = item.querySelector('img');
      if (!image) return '';
      const source = image.currentSrc || image.getAttribute('src') || image.getAttribute('srcset') || '';
      try {
        return decodeURIComponent(source).toLowerCase();
      } catch (error) {
        return source.toLowerCase();
      }
    };

    const mediaView = (source) => {
      if (/(?:^|[-_])left(?:[-_.]|$)/.test(source)) return 'left';
      if (/(?:^|[-_])right(?:[-_.]|$)/.test(source)) return 'right';
      if (/(?:^|[-_])back(?:[-_.]|$)/.test(source) && !source.includes('front-and-back')) return 'back';
      if (/(?:^|[-_])front(?:[-_.]|$)/.test(source) && !source.includes('front-and-back')) return 'front';
      return '';
    };

    const itemView = (item) => item.dataset.strobeFallbackView || mediaView(mediaSource(item));

    const selectedColour = () => {
      const selectedInput = Array.from(
        productInfo?.querySelectorAll('.product-form__input input[type="radio"]:checked') || []
      ).find((input) => {
        const field = input.closest('.product-form__input');
        const label = field?.querySelector('.form__label')?.textContent || '';
        return /colou?r/i.test(label);
      });
      return selectedInput?.value?.trim() || 'Black';
    };

    const colourSlug = (value) =>
      value
        .toLowerCase()
        .trim()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

    const sourceMatchesColour = (source, value) => {
      const slug = colourSlug(value);
      if (!slug) return false;
      if (slug === 'black' && source.includes('vintage-black')) return false;
      return source.includes(`-${slug}-`);
    };

    const addFallbackGalleryMedia = () => {
      if (!mediaList || !productTheme) return;
      const fallbacks = fallbackGalleryMedia[productTheme.dataset.strobeProductHandle] || [];
      if (!fallbacks.length) return;
      const items = Array.from(mediaList.querySelectorAll('.product__media-item'));
      const frontItem = items.find((item) => {
        const source = mediaSource(item);
        return /(?:^|[-_])black(?:[-_.]|$)/.test(source) && mediaView(source) === 'front';
      });
      if (!frontItem) return;

      fallbacks.forEach((fallback) => {
        if (mediaList.querySelector(`[data-strobe-fallback-view="${fallback.view}"]`)) return;
        const item = frontItem.cloneNode(true);
        item.dataset.strobeFallbackView = fallback.view;
        item.dataset.strobeSourceUrl = fallback.url.toLowerCase();
        item.dataset.mediaId = `strobe-black-${fallback.view}`;
        item.removeAttribute('id');
        item.hidden = false;
        item.setAttribute('aria-hidden', 'false');
        item.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        item.querySelectorAll('img').forEach((image) => {
          image.src = fallback.url;
          image.srcset = fallback.url;
          image.alt = `${document.querySelector('.product__title')?.textContent?.trim() || 'Product'} — black ${fallback.view} view`;
          image.removeAttribute('loading');
        });
        item.querySelectorAll('.product__media-toggle, button').forEach((button) => button.remove());
        mediaList.append(item);
      });
    };

    const setupMainImageHover = (selected) => {
      const frontItem = selected.find((item) => itemView(item) === 'front');
      const backItem = selected.find((item) => itemView(item) === 'back');
      const frontMedia = frontItem?.querySelector('.product__media');
      const backImage = backItem?.querySelector('img');
      mediaList?.querySelectorAll('.strobe-hover-back-image').forEach((image) => {
        if (!frontMedia || !frontMedia.contains(image)) image.remove();
      });
      if (!frontMedia || !backImage) {
        frontMedia?.querySelector('.strobe-hover-back-image')?.remove();
        return;
      }

      const backSource = mediaSource(backItem);
      const currentHover = frontMedia.querySelector('.strobe-hover-back-image');
      if (currentHover?.dataset.strobeSourceUrl === backSource) return;
      currentHover?.remove();
      const hoverImage = backImage.cloneNode(true);
      hoverImage.className = `${hoverImage.className} strobe-hover-back-image`.trim();
      hoverImage.dataset.strobeSourceUrl = backSource;
      hoverImage.removeAttribute('id');
      hoverImage.alt = '';
      hoverImage.setAttribute('aria-hidden', 'true');
      hoverImage.removeAttribute('loading');
      frontMedia.append(hoverImage);
    };

    const filterProductGallery = () => {
      if (!gallery || !mediaList) return;
      addFallbackGalleryMedia();
      const items = Array.from(mediaList.querySelectorAll('.product__media-item'));
      if (items.length < 2) return;

      const imageItems = items.filter((item) => item.querySelector('img'));
      const activeColour = selectedColour();
      const colourItems = imageItems.filter((item) =>
        sourceMatchesColour(mediaSource(item), activeColour)
      );
      if (!colourItems.length) return;

      const selected = [];
      ['front', 'back', 'left', 'right'].forEach((view) => {
        const match = colourItems.find((item) => itemView(item) === view);
        if (match && !selected.includes(match)) selected.push(match);
      });
      if (!selected.length) selected.push(...colourItems.slice(0, 4));

      items.forEach((item) => {
        const visible = selected.includes(item);
        item.hidden = !visible;
        item.setAttribute('aria-hidden', visible ? 'false' : 'true');
          item.toggleAttribute('inert', !visible);
      });

      const visibleOrder = Array.from(mediaList.querySelectorAll('.product__media-item'))
        .filter((item) => selected.includes(item));
      const orderMatches = visibleOrder.every((item, index) => item === selected[index]);
      if (!orderMatches) selected.forEach((item) => mediaList.append(item));

      const visibleIds = new Set(
        selected
          .map((item) => item.dataset.mediaId || item.getAttribute('data-media-id') || '')
          .filter(Boolean)
      );
      gallery.querySelectorAll('.thumbnail-list__item').forEach((thumbnail) => {
        const button = thumbnail.querySelector('[data-target]');
        const target = button?.dataset.target || '';
        const mediaId = target.split('-').pop() || '';
        thumbnail.hidden = visibleIds.size > 0 && !visibleIds.has(mediaId);
      });

      const status = gallery.querySelector('.slider-counter--current');
      const total = gallery.querySelector('.slider-counter--total');
      if (status) status.textContent = '1';
      if (total) total.textContent = String(selected.length);
      setupMainImageHover(selected);
    };

    filterProductGallery();
    if (gallery) {
      const galleryObserver = new MutationObserver(() => {
        window.clearTimeout(galleryFilterTimer);
        galleryFilterTimer = window.setTimeout(filterProductGallery, 40);
      });
      galleryObserver.observe(gallery, { childList: true, subtree: true });
    }

    const colorMap = {
      black: '#111111',
      'vintage black': '#242424',
      white: '#f5f5f5',
      navy: '#14213d',
      'navy blazer': '#16233f',
      purple: '#6f2da8',
      red: '#c71920',
      'team red': '#c41f2b',
      'dark chocolate': '#3b241c',
      cardinal: '#8a1538',
      'turf green': '#1f6b3a',
      'forest green': '#244b35',
      sapphire: '#1d4e89',
      heliconia: '#d62e83',
      charcoal: '#4b4b4b',
      'charcoal heather': '#4f5154',
      'dark heather': '#3f4145',
      'military green': '#4b5320',
      maroon: '#6b2538',
      'team royal': '#1f4f9d',
      'dusty rose': '#b98086',
      'carbon grey': '#55585a',
      'sport grey': '#9b9da0',
      orange: '#e66a1f',
      'tropical blue': '#23a9c7',
      'brown savana': '#765544',
      'brown savanna': '#765544',
      azalea: '#d85f8f',
      gold: '#d6a91f',
      grey: '#777777',
      gray: '#777777',
      pink: '#e7a0b5',
      blue: '#2667a8',
      green: '#2f6b3d'
    };

    const pushEvent = (action, detail = {}) => {
      if (window.strobeAnalyticsExcluded) return;
      const payload = {
        event: 'strobe_product_interaction',
        action,
        product_id: productTheme?.dataset.strobeProductId || '',
        product_title: document.querySelector('.product__title')?.textContent?.trim() || '',
        product_url: window.location.pathname,
        ...detail
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('strobe:product-interaction', { detail: payload }));
    };

    const syncReviewSummary = () => {
      if (!reviewSummary || !reviewStatus) return;
      const reviewText = reviewSection?.textContent?.replace(/\s+/g, ' ').trim() || '';
      const reviewMatch = reviewText.match(/\b([1-9]\d*)\s+(?:customer\s+)?reviews?\b/i);
      const reviewCount = reviewMatch ? Number(reviewMatch[1]) : 0;
      if (reviewCount > 0) {
        reviewSummary.href = '#strobe-product-reviews';
        reviewSummary.removeAttribute('aria-disabled');
        reviewStatus.textContent = `View ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'} →`;
        return;
      }
      reviewSummary.removeAttribute('href');
      reviewSummary.setAttribute('aria-disabled', 'true');
      reviewStatus.textContent = 'No reviews';
    };

    syncReviewSummary();
    if (reviewSection) {
      const reviewObserver = new MutationObserver(syncReviewSummary);
      reviewObserver.observe(reviewSection, { childList: true, subtree: true, characterData: true });
    }

    const getFieldName = (field) => {
      const label = field.querySelector('.form__label');
      return label?.childNodes?.[0]?.textContent?.trim() || label?.textContent?.trim() || '';
    };

    const getInputLabel = (field, input) =>
      Array.from(field.querySelectorAll('label')).find((label) => label.htmlFor === input.id);

    const addSelectedValue = (field, inputs) => {
      const fieldLabel = field.querySelector('.form__label');
      if (!fieldLabel) return null;
      let value = fieldLabel.querySelector('.strobe-option-value');
      if (!value) {
        value = fieldLabel.querySelector('[data-selected-value]');
        if (value) {
          value.classList.add('strobe-option-value');
        } else {
          value = document.createElement('span');
          value.className = 'strobe-option-value';
          fieldLabel.append(value);
        }
      }

      const usesNativeSelectedValue = value.hasAttribute('data-selected-value');
      const sync = () => {
        const selected = inputs.find((input) => input.checked);
        value.textContent = selected
          ? (usesNativeSelectedValue ? selected.value : ': ' + selected.value)
          : '';
      };

      inputs.forEach((input) => input.addEventListener('change', sync));
      sync();
      return value;
    };

    const buildOptionGrid = (field, className) => {
      const inputs = Array.from(field.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return [];
      field.classList.add(className);
      const grid = document.createElement('div');
      grid.className = 'strobe-option-grid';
      inputs.forEach((input) => {
        const label = getInputLabel(field, input);
        if (!label) return;
        grid.append(input, label);
      });
      field.append(grid);
      addSelectedValue(field, inputs);
      return inputs;
    };

    const setupColorField = (field) => {
      const inputs = buildOptionGrid(field, 'strobe-color-field');
      if (!inputs.length) return;

      const mappedInputs = [];
      inputs.forEach((input) => {
        const label = getInputLabel(field, input);
        if (!label) return;
        const key = input.value.trim().toLowerCase();
        const color = colorMap[key];
        if (!color) {
          label.hidden = true;
          label.classList.add('strobe-unmapped-color');
          return;
        }
        label.style.setProperty('--swatch-color', color);
        label.title = input.value;
        label.setAttribute('aria-label', input.value);
        mappedInputs.push(input);
      });

      mappedInputs.forEach((input, index) => {
        const label = getInputLabel(field, input);
        if (!label) return;
        if (index >= 6 && !input.checked) label.classList.add('strobe-option-hidden');
      });

      if (mappedInputs.length <= 6) return;
      const hiddenCount = mappedInputs.length - 6;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'strobe-more-colors';
      button.textContent = `+ ${hiddenCount} more colours`;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        field.querySelectorAll('.strobe-option-hidden').forEach((label) => {
          label.classList.remove('strobe-option-hidden');
        });
        button.remove();
        pushEvent('variant_more_open', { option_name: 'Color' });
      });
      field.append(button);

      mappedInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const label = getInputLabel(field, input);
          if (input.checked && label?.classList.contains('strobe-option-hidden')) button.click();
        });
      });
    };

    const setupSizeField = (field) => {
      const inputs = buildOptionGrid(field, 'strobe-size-field');
      if (!inputs.length) return;
      const fieldLabel = field.querySelector('.form__label');
      if (fieldLabel && !fieldLabel.querySelector('.strobe-size-guide-link')) {
        const sizeGuide = document.createElement('a');
        sizeGuide.className = 'strobe-size-guide-link';
        sizeGuide.href = '#strobe-product-size-guide';
        sizeGuide.textContent = 'Size guide →';
        fieldLabel.append(sizeGuide);
      }

      const storageKey = 'strobe_preferred_size';
      let savedSize = '';
      try {
        savedSize = localStorage.getItem(storageKey) || '';
      } catch (error) {
        savedSize = '';
      }

      const savedInput = inputs.find((input) => input.value === savedSize && !input.disabled);
      if (savedInput && !savedInput.checked) {
        savedInput.checked = true;
        savedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (savedSize) {
        const note = document.createElement('p');
        note.className = 'strobe-previous-size';
        note.textContent = `Your previous size: ${savedSize}`;
        field.append(note);
      }

      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          try {
            localStorage.setItem(storageKey, input.value);
          } catch (error) {
            return;
          }
        });
      });
    };

    let fields = [];
    const initializeVariantFields = () => {
      fields = productInfo
        ? Array.from(productInfo.querySelectorAll('.product-form__input'))
        : [];
      fields.forEach((field) => {
        const name = getFieldName(field);
        if (/colou?r/i.test(name) && !field.classList.contains('strobe-color-field')) {
          setupColorField(field);
        }
        if (/size/i.test(name) && !field.classList.contains('strobe-size-field')) {
          setupSizeField(field);
        }
      });
    };
    initializeVariantFields();

    const addButton = productInfo?.querySelector('.product-form__submit');
    const buttonContainer = productInfo?.querySelector('.product-form__buttons');
    let confirmation;
    if (buttonContainer) {
      confirmation = document.createElement('div');
      confirmation.className = 'strobe-selection-confirmation';
      confirmation.setAttribute('aria-live', 'polite');
      buttonContainer.prepend(confirmation);
    }

    const selectedOptions = () =>
      fields
        .map((field) => field.querySelector('input[type="radio"]:checked')?.value)
        .filter(Boolean);

    const syncConfirmation = () => {
      if (!confirmation || !addButton) return;
      const options = selectedOptions();
      const buttonText = addButton.textContent.trim();
      const available = !addButton.disabled;
      confirmation.innerHTML = '';
      const strong = document.createElement('strong');
      strong.textContent = options.join(' / ') || 'Choose your options';
      const status = document.createElement('span');
      status.textContent = available ? 'Selection ready — delivery shown at checkout' : buttonText;
      confirmation.append(strong, status);
    };

    const paymentButton = productInfo?.querySelector('.shopify-payment-button');
    if (paymentButton && !paymentButton.closest('.strobe-express-checkout')) {
      const express = document.createElement('details');
      express.className = 'strobe-express-checkout';
      const summary = document.createElement('summary');
      summary.textContent = 'Express checkout options';
      paymentButton.before(express);
      express.append(summary, paymentButton);
    }

    const sticky = document.createElement('div');
    sticky.className = 'strobe-mobile-purchase';
    sticky.innerHTML = '<span class="strobe-mobile-purchase__price"></span><button class="strobe-mobile-purchase__button" type="button"></button>';
    document.body.append(sticky);
    const stickyPrice = sticky.querySelector('.strobe-mobile-purchase__price');
    const stickyButton = sticky.querySelector('.strobe-mobile-purchase__button');

    const syncSticky = () => {
      const price = productInfo?.querySelector('.price')?.textContent?.replace(/\s+/g, ' ').trim() || '';
      stickyPrice.textContent = price;
      stickyButton.textContent = addButton?.textContent?.trim() || 'Select options';
      stickyButton.disabled = Boolean(addButton?.disabled && /sold out/i.test(stickyButton.textContent));
    };

    stickyButton.addEventListener('click', () => {
      if (addButton && !addButton.disabled) {
        addButton.click();
        return;
      }
      productInfo?.querySelector('variant-selects, variant-radios, .product-form__input')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });

    if (addButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
      observer.observe(addButton);
    }

    const productObserver = new MutationObserver(() => {
      syncConfirmation();
      syncSticky();
    });
    const priceElement = productInfo?.querySelector('.price');
    if (priceElement) productObserver.observe(priceElement, { childList: true, subtree: true, characterData: true });
    if (addButton) productObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    let variantRefreshTimer;
    if (productInfo) {
      const variantObserver = new MutationObserver((records) => {
        const variantChanged = records.some((record) => {
          const target = record.target instanceof Element ? record.target : null;
          if (target?.closest('variant-selects, variant-radios')) return true;
          return Array.from(record.addedNodes).some((node) => {
            if (!(node instanceof Element)) return false;
            return node.matches('variant-selects, variant-radios, .product-form__input')
              || Boolean(node.querySelector('.product-form__input'));
          });
        });
        if (!variantChanged) return;
        window.clearTimeout(variantRefreshTimer);
        variantRefreshTimer = window.setTimeout(() => {
          initializeVariantFields();
          syncConfirmation();
          syncSticky();
          filterProductGallery();
        }, 40);
      });
      variantObserver.observe(productInfo, { childList: true, subtree: true });
    }

    syncConfirmation();
    syncSticky();

    if (addButton) {
      const label = addButton.querySelector('span');
      addButton.dataset.strobeOriginalLabel =
        label?.textContent?.trim() || addButton.textContent.trim() || 'Add to cart';

      addButton.addEventListener('click', (event) => {
        if (addButton.dataset.strobeSubmitting !== 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        pushEvent('add_to_cart_repeat_blocked');
      }, true);

      addButton.closest('form')?.addEventListener('submit', () => {
        if (addButton.dataset.strobeSubmitting === 'true') return;
        addButton.dataset.strobeSubmitting = 'true';
        addButton.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Adding…';

        window.setTimeout(() => {
          if (addButton.dataset.strobeSubmitting !== 'true') return;
          delete addButton.dataset.strobeSubmitting;
          addButton.removeAttribute('aria-busy');
          if (label) label.textContent = addButton.dataset.strobeOriginalLabel || 'Add to cart';
        }, 10000);
      }, true);

      document.addEventListener('strobe:cart-add-success', () => {
        delete addButton.dataset.strobeSubmitting;
        addButton.removeAttribute('aria-busy');
        if (label) label.textContent = 'Added to cart';
        pushEvent('add_to_cart_success');
        window.setTimeout(() => {
          if (label) label.textContent = addButton.dataset.strobeOriginalLabel || 'Add to cart';
        }, 1800);
      });

      document.addEventListener('strobe:cart-add-error', () => {
        delete addButton.dataset.strobeSubmitting;
        addButton.removeAttribute('aria-busy');
        if (label) label.textContent = 'Try again';
        pushEvent('add_to_cart_error');
      });
    }

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.closest('.product-form__input')) return;
      if (input.type !== 'radio' && input.name !== 'id') return;
      pushEvent('variant_select', {
        option_name: input.name || '',
        option_value: input.value || ''
      });
      window.setTimeout(() => {
        initializeVariantFields();
        syncConfirmation();
        syncSticky();
        filterProductGallery();
      }, 120);
    });

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (target.closest('.product-form__submit')) {
        pushEvent('add_to_cart');
        return;
      }

      if (target.closest('[href="#strobe-product-size-guide"], [href="#strobe-materials-fit-care"]')) {
        pushEvent('size_guide_open');
        return;
      }

      if (target.closest('.shopify-payment-button, [name="checkout"], a[href*="/checkout"]')) {
        pushEvent('checkout_click');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-strobe-recently-viewed]');
    if (!section) return;

    const currentHandle = section.dataset.currentHandle;
    const clearanceDiscountPercent = Math.max(0, Math.min(90, Number(section.dataset.clearanceDiscountPercent || 30)));
    const storageKey = 'strobe_recently_viewed';
    let handles = [];

    try {
      handles = JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (error) {
      handles = [];
    }

    handles = handles.filter((handle) => handle && handle !== currentHandle);
    const displayHandles = handles.slice(0, 4);
    const nextHandles = [currentHandle, ...handles].slice(0, 8);

    try {
      localStorage.setItem(storageKey, JSON.stringify(nextHandles));
    } catch (error) {
      return;
    }

    if (!displayHandles.length) return;

    const grid = section.querySelector('[data-strobe-recently-viewed-grid]');
    if (!grid) return;

    const escapeHtml = (value) => {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    };

    const money = (cents) => {
      const currency = window.Shopify?.currency?.active || 'CAD';
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    };

    Promise.all(
      displayHandles.map((handle) =>
        fetch(`/products/${encodeURIComponent(handle)}.js`)
          .then((response) => {
            if (!response.ok) throw new Error('Product unavailable');
            return response.json();
          })
          .catch(() => null)
      )
    ).then((products) => {
      const cards = products
        .filter(Boolean)
        .map((item) => {
          const image = item.featured_image || item.images?.[0] || '';
          const url = item.url || `/products/${item.handle}`;
          const rawTags = Array.isArray(item.tags) ? item.tags : String(item.tags || '').split(',');
          const isClearance = rawTags.some((tag) => String(tag).trim().toLowerCase() === 'clearance');
          const originalPrice = Number(item.price || 0);
          const salePrice = isClearance && clearanceDiscountPercent > 0
            ? Math.floor(originalPrice * (100 - clearanceDiscountPercent) / 100)
            : originalPrice;
          const priceMarkup = isClearance && salePrice < originalPrice
            ? `<p class="strobe-clearance-inline"><s class="strobe-clearance-price__original">${money(originalPrice)}</s><span class="strobe-clearance-price__sale">${money(salePrice)}</span></p>`
            : `<p>${money(originalPrice)}</p>`;
          return `
            <article class="strobe-recent-card">
              <a class="strobe-recent-card__image" href="${escapeHtml(url)}">
                <img src="${escapeHtml(image)}" alt="${escapeHtml(item.title)}" loading="lazy" width="800" height="1000">
              </a>
              <h3>${escapeHtml(item.title)}</h3>
              ${priceMarkup}
              <a class="strobe-recent-card__button" href="${escapeHtml(url)}">View product</a>
            </article>
          `;
        })
        .join('');

      if (!cards) return;
      grid.innerHTML = cards;
      section.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-release-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-bandcamp-click]');
    if (!link) return;
    if (window.strobeAnalyticsExcluded) return;

    const analyticsParameters = {
      release_title: link.dataset.releaseTitle || '',
      release_handle: link.dataset.releaseHandle || '',
      click_location: link.dataset.clickLocation || '',
      destination_url: link.href
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'bandcamp_purchase_click', analyticsParameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bandcamp_purchase_click',
        ...analyticsParameters
      });
    }
  });

  const releasePage = document.querySelector('[data-release-page]');
  const purchaseButton = releasePage && releasePage.querySelector('.strobe-release-detail__buy');
  const mobileBar = releasePage && releasePage.querySelector('[data-mobile-bandcamp-bar]');

  if (purchaseButton && mobileBar && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      mobileBar.classList.toggle('is-hidden', entries[0].isIntersecting);
    });
    observer.observe(purchaseButton);
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobe-wishlist-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    const start = () => {
      const api = window.StrobeWishlist;
      if (!api) {
        window.setTimeout(start, 30);
        return;
      }

      const grid = page.querySelector('[data-wishlist-grid]');
      const empty = page.querySelector('[data-wishlist-empty]');
      const addAllButton = page.querySelector('[data-wishlist-add-all]');
      const suggestions = page.querySelector('[data-wishlist-suggestions]');
      const productCache = new Map();
      const escapeHtml = (value) => {
        const element = document.createElement('div');
        element.textContent = String(value || '');
        return element.innerHTML;
      };

      const heart = `
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"></path>
        </svg>`;

      const renderOptions = (item) => {
        const product = productCache.get(item.handle);
        if (!product || !Array.isArray(product.variants) || product.variants.length < 2) {
          return item.variantTitle && item.variantTitle !== 'Default Title'
            ? `<p class="strobe-wishlist-card__variant">${escapeHtml(item.variantTitle)}</p>`
            : '<p class="strobe-wishlist-card__variant"></p>';
        }

        const selectedVariant = product.variants.find((variant) => String(variant.id) === String(item.variantId))
          || product.variants[0];
        const optionNames = Array.isArray(product.options) ? product.options : [];
        const selectedOptions = Array.isArray(selectedVariant.options) ? selectedVariant.options : [];
        const selectors = optionNames.map((option, index) => {
          const optionName = typeof option === 'string' ? option : option.name || `Option ${index + 1}`;
          const values = [...new Set(product.variants.map((variant) => variant.options?.[index]).filter(Boolean))];
          if (!values.length) return '';
          const choices = values.map((value) =>
            `<option value="${escapeHtml(value)}" ${value === selectedOptions[index] ? 'selected' : ''}>${escapeHtml(value)}</option>`
          ).join('');
          return `
            <label class="strobe-wishlist-card__option">
              <span>${escapeHtml(optionName)}</span>
              <select data-wishlist-option="${index}" aria-label="${escapeHtml(`${optionName}: ${item.title}`)}">${choices}</select>
            </label>`;
        }).join('');
        return selectors ? `<div class="strobe-wishlist-card__options">${selectors}</div>` : '';
      };

      const render = () => {
        const items = api.getWishlist();
        grid.innerHTML = '';
        empty.hidden = items.length > 0;
        grid.hidden = items.length === 0;

        items.forEach((item) => {
          const article = document.createElement('article');
          article.className = 'strobe-wishlist-card';
          article.dataset.productHandle = item.handle;
          const image = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" width="700" height="700">`
            : '';
          const variant = renderOptions(item);
          const unavailable = item.available === false
            ? `<p class="strobe-wishlist-card__status">${escapeHtml(api.labels.unavailable)}</p>`
            : '';
          const hasClearancePrice = Number(item.clearancePercent || 0) > 0
            && Number(item.originalPrice || 0) > Number(item.price || 0);
          const priceMarkup = hasClearancePrice
            ? `<p class="strobe-wishlist-card__price strobe-clearance-inline"><s class="strobe-clearance-price__original">${escapeHtml(api.formatMoney(item.originalPrice, item.currency))}</s><span class="strobe-clearance-price__sale">${escapeHtml(api.formatMoney(item.price, item.currency))}</span></p>`
            : `<p class="strobe-wishlist-card__price">${escapeHtml(api.formatMoney(item.price, item.currency))}</p>`;
          article.innerHTML = `
            <div class="strobe-wishlist-card__media">
              <a href="${escapeHtml(item.url || `${api.shopRoot}products/${item.handle}`)}">${image}</a>
              <button class="strobe-wishlist-card__remove" type="button" data-wishlist-remove="${escapeHtml(item.handle)}" aria-label="${escapeHtml(`${api.labels.remove}: ${item.title}`)}">${heart}</button>
            </div>
            <div class="strobe-wishlist-card__body">
              <h2><a href="${escapeHtml(item.url || `${api.shopRoot}products/${item.handle}`)}">${escapeHtml(item.title)}</a></h2>
              ${priceMarkup}
              ${variant}
              ${unavailable}
              <div class="strobe-wishlist-card__actions">
                <a class="strobe-wishlist-page__button strobe-wishlist-page__button--view" href="${escapeHtml(item.url || `${api.shopRoot}products/${item.handle}`)}">${escapeHtml(api.labels.viewProduct)}</a>
                <button
                  class="strobe-wishlist-page__button strobe-wishlist-page__button--cart"
                  type="button"
                  data-wishlist-add-cart="${escapeHtml(item.variantId)}"
                  ${item.available === false || !item.variantId ? 'disabled' : ''}
                >${escapeHtml(api.labels.addToCart)}</button>
              </div>
            </div>`;
          grid.appendChild(article);
        });

        document.querySelectorAll('[data-wishlist-page-count]').forEach((count) => {
          count.textContent = String(items.length);
        });
        const availableItems = items.filter((item) => item.available !== false && item.variantId);
        addAllButton.hidden = items.length === 0;
        addAllButton.disabled = availableItems.length === 0;
        if (suggestions) {
          let visibleSuggestions = 0;
          suggestions.querySelectorAll('[data-wishlist-suggestion]').forEach((card) => {
            card.hidden = api.isInWishlist(card.dataset.wishlistSuggestion);
            if (!card.hidden) visibleSuggestions += 1;
          });
          suggestions.hidden = visibleSuggestions === 0;
        }
      };

      const refresh = async () => {
        const items = api.getWishlist();
        const refreshed = await Promise.all(items.map(async (item) => {
          try {
            const product = await api.fetchProduct(item.handle);
            productCache.set(item.handle, product);
            return { ...item, ...api.itemFromProduct(product, item.variantId), addedAt: item.addedAt };
          } catch (error) {
            return { ...item, available: false };
          }
        }));
        try {
          window.localStorage.setItem('strobe_wishlist', JSON.stringify(refreshed));
          window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: refreshed, action: 'refresh' } }));
        } catch (error) {
          return;
        }
        render();
      };

      page.addEventListener('click', async (event) => {
        const removeButton = event.target.closest('[data-wishlist-remove]');
        if (removeButton) {
          api.removeFromWishlist(removeButton.dataset.wishlistRemove);
          render();
          return;
        }

        const cartButton = event.target.closest('[data-wishlist-add-cart]');
        if (!cartButton || cartButton.disabled) return;
        cartButton.disabled = true;
        cartButton.textContent = api.labels.addingToCart;
        try {
          await api.addVariantToCart(cartButton.dataset.wishlistAddCart);
          cartButton.textContent = api.labels.addedToCart;
          api.announce(api.labels.addedToCart);
        } catch (error) {
          cartButton.textContent = api.labels.cartError;
          api.announce(api.labels.cartError);
        }
        window.setTimeout(() => {
          cartButton.textContent = api.labels.addToCart;
          cartButton.disabled = false;
        }, 1600);
      });
      page.addEventListener('change', (event) => {
        const selector = event.target.closest('[data-wishlist-option]');
        if (!selector) return;
        const card = selector.closest('[data-product-handle]');
        const product = productCache.get(card?.dataset.productHandle);
        if (!card || !product) return;
        const selectedOptions = [...card.querySelectorAll('[data-wishlist-option]')].map((select) => select.value);
        const variant = product.variants.find((candidate) =>
          candidate.options?.every((value, index) => value === selectedOptions[index])
        );
        if (!variant) return;
        const refreshed = api.itemFromProduct(product, variant.id);
        api.updateWishlistItem(card.dataset.productHandle, refreshed);
        render();
      });
      addAllButton.addEventListener('click', async () => {
        const items = api.getWishlist().filter((item) => item.available !== false && item.variantId);
        if (!items.length) return;
        addAllButton.disabled = true;
        addAllButton.textContent = api.labels.addingAll;
        try {
          await api.addVariantsToCart(items.map((item) => ({ id: item.variantId, quantity: 1 })));
          addAllButton.textContent = api.labels.addedAll;
          api.announce(api.labels.addedAll);
        } catch (error) {
          addAllButton.textContent = api.labels.cartError;
          api.announce(api.labels.cartError);
        }
        window.setTimeout(() => {
          addAllButton.textContent = api.labels.addAll;
          addAllButton.disabled = false;
        }, 1800);
      });
      window.addEventListener('wishlist:updated', render);
      render();
      refresh();
    };

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strobefest-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ticket-platform]');
    if (!link) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ticket_platform_selected',
      ticket_platform: link.dataset.ticketPlatform,
      ticket_type: link.dataset.ticketName,
      event_name: 'StrobeFest 2027',
      link_url: link.href
    });
  });

  } catch(e) { console.error(e); }
})();
})();
